import React, { createContext, useContext } from 'react';
import { MLSResult } from '@/utils/types/MLSResult';

interface ListingsContextType {
    listings: MLSResult;
    searchParams?: URLSearchParams;
    handlePageChange: ( newPage: number ) => void;
    handleSortChange: ( sortValue: string ) => void;
    handleSearchSubmit: ( e: React.FormEvent<HTMLFormElement> ) => void;
}

export const ListingsContext = createContext<ListingsContextType | undefined>( undefined );

export const useListings = () => {
    const context = useContext( ListingsContext );
    if ( ! context ) {
        throw new Error( 'useListings must be used within a ListingsProvider' );
    }
    return context;
};